<app-main-contents>
  <app-title [title]="title"></app-title>
  <app-sending *ngIf="sending"></app-sending>
  <app-action-grid
    [data]="data"
    [loading]="loading"
    [rowSelection]="rowSelection"
    [columns]="columns"
    [actionButtons]="actionButtons"
    [cellClasses]="cellClasses"
    [exportExcelButton]="true"
    (actionCommit)="actionCommit($event)"
  ></app-action-grid>
</app-main-contents>

<app-dialog
  *ngIf="dialogOpen"
  [title]="'請求先情報'"
  widthSize="large"
  [hideCommitButton]="true"
  (cancel)="dialogOpen = false"
>
  <app-invoice-target-view
    [selectedCd]="invoiceTargetCd"
  ></app-invoice-target-view>
</app-dialog>
